<script>
  import { ignoreCaseSort } from '../../../shared/utils/Sort.svelte'
  import { createProps, defaultValue, getComponent, getComponentProps } from '../helpers'

  export let ui;

  const p = createProps();
  export let value = p.value;
  export let errors = p.errors;
  export let schema = p.schema;
  export let components = p.components;
  export let props = p.props;
  export let key = p.key;
  let disabledValue = "";
  /* recalc a default value */
  if (schema && value == null) {
      value = defaultValue(schema, value);
  }
  let format = '';
  format = (schema && schema.format) || '';
  let maxlength = "" + 524288;
  if (schema.maxLength) {
    maxlength = "" + schema.maxLength;
  }
  let readonly = ui && ui["ui:readonly"] ? "readonly" : "";
  let disabled = ui && ui["ui:disabled"] ? true : false;
  if (disabled) {
    disabledValue = value;
  }
  let widget = ui && ui["ui:widget"] ? ui["ui:widget"] : null;
</script>

{#if schema && components}
  <svelte:component
    this={getComponent(components.wrapper)}
    {...getComponentProps(components.wrapper)}
    {schema}
    {key}
    {errors}>
    {#if disabled}
      <input class="form-input" readonly type="text" value={disabledValue} />
    {:else if format == 'date-time'}
      <input {...props} class="form-input" {readonly} {maxlength} type="datetime" bind:value />
    {:else if format == 'date'}
      <input {...props} class="form-input" {readonly} {maxlength} type="date" bind:value />
    {:else if format == 'time'}
      <input {...props} class="form-input" {readonly} {maxlength} type="time" bind:value />
    {:else if format == 'email'}
      <input {...props} class="form-input" {readonly} {maxlength} type="email" bind:value />
    {:else if format == 'url'}
      <input {...props} class="form-input" {readonly} {maxlength} type="url" bind:value />
    {:else if schema.enum}
      <select {...props} class="form-select" bind:value>
          <option disabled selected>not-set</option>
          {#if schema.enum.length > 0}
              {#each schema.enum.sort(ignoreCaseSort) as option}
                {#if option.split("|").length == 2}
                  <option value={option.split("|")[0]}>{option.split("|")[1]}</option>
                {:else}
                  <option>{option}</option>
                {/if}
              {/each}
          {/if}
      </select>
    {:else if widget == "textarea"}
      <textarea {...props} class="form-input" {readonly} {maxlength} type="text" {...props} bind:value rows="3"></textarea>
    {:else if widget == "color"}
      <input {...props} class="form-input" {readonly} {maxlength} type="color" bind:value />
    {:else if widget == "password"}
      <input {...props} class="form-input" {readonly} {maxlength} type="password" bind:value />
    {:else if widget == "hidden"}
      <input {...props} type="hidden" {maxlength} bind:value />
    {:else if widget == "upload"}
      <input {...props} type="file" multiple bind:value style="position: relative;top: 10px;" />
    {:else}
      <input class="form-input" {readonly} {maxlength} type="text" {...props} bind:value />
    {/if}
  </svelte:component>
{/if}

<style>
  .form-group {
      margin: 0;
  }
</style>